// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c923e29e","703":"68ff776a"}[chunkId] + ".chunk.js";
};